module.exports = __webpack_public_path__ + "static/media/menu_embed.3ba667b7.svg";